import { Button } from 'antd'
import { Component, type ErrorInfo, type ReactNode } from 'react'

interface RouteErrorBoundaryProps {
  children: ReactNode
  componentPath?: string
}

interface RouteErrorBoundaryState {
  error: Error | null
}

export default class RouteErrorBoundary extends Component<
  RouteErrorBoundaryProps,
  RouteErrorBoundaryState
> {
  state: RouteErrorBoundaryState = { error: null }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[RouteErrorBoundary]', this.props.componentPath, error, info)
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    const { error } = this.state
    if (!error) return this.props.children

    const isChunkError =
      /Failed to fetch dynamically imported module|Loading chunk|Importing a module script failed/i.test(
        error.message,
      )

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 12,
          minHeight: 320,
          padding: 24,
          textAlign: 'center',
        }}
      >
        <h2 style={{ margin: 0, fontSize: 18, color: '#333' }}>页面加载失败</h2>
        <p style={{ margin: 0, maxWidth: 480, color: '#666', lineHeight: 1.6 }}>
          {isChunkError
            ? '开发环境下模块缓存可能已过期，请刷新页面后重试。'
            : error.message || '未知错误'}
        </p>
        <Button type="primary" onClick={this.handleReload}>
          刷新页面
        </Button>
      </div>
    )
  }
}
